import { Component, Input } from "@angular/core";
import { DestroyableComponentBase } from "../../../../../utils/components/destroyable-component-base";
import { ICustomerSelectorPopoverItem } from "./i-customer-selector-popover-item";

@Component({
	selector: "calao-customer-selector-popover-item",
	templateUrl: "./customer-selector-popover-item.component.html",
	styleUrls: ["./customer-selector-popover-item.component.scss"],
	standalone: false
})
export class CustomerSelectorPopoverItemComponent extends DestroyableComponentBase {
	//#region PROPERTIES

	@Input({ required: true }) public item!: ICustomerSelectorPopoverItem;

	//#endregion

	//#region METHODS

	constructor() {
		super();
	}

	//#endregion
}
